import mergeProps from '@vue/babel-helper-vue-jsx-merge-props'

export default
{
	functional: true,

	name: 'IconX',

	props:
	{
		size:
		{
			type: String,
			default: '24'
		},
	},

	render(h, ctx)
	{
		const size = parseInt(ctx.props.size) + 'px'

		let attrs = ctx.data.attrs || {}

		attrs.width = attrs.width || size
		attrs.height = attrs.height || size

		ctx.data.attrs = attrs

		return h
		(
			'svg',
			mergeProps
			([
				{
					attrs:
					{
						xmlns: "http://www.w3.org/2000/svg",
						width: "24",
						height: "24",
						viewBox: "0 0 24 24",
						"stroke-width": "2",
						stroke: "currentColor",
						fill: "none",
						"stroke-linecap": "round",
						"stroke-linejoin": "round"
					},
					"class": "icon"
				},
				ctx.data
			]),
			[
				h("path", { attrs: { d: "M0 0h24v24H0z", stroke: "none" } }),
				h("line", { attrs: { x1: "18", y1: "6", x2: "6", y2: "18" } }),
				h("line", { attrs: { x1: "6", y1: "6", x2: "18", y2: "18" } })
			]
		)
	}
}